export class Logs {

    constructor(store, logsContainer) {
        this.store = store;
        this.logsContainer = logsContainer;
        this.resultsContainer = document.createElement("div");
        this.resultsContainer.className = 'wrapper width-100 height-100'
    }

    render(logs) {
        this.resultsContainer.innerHTML = "";
        const section = document.createElement("div");
        section.className = "logColumn ";

        // FEJLÉC
        const title = document.createElement("div");
        title.className = "section-title";
        title.textContent = "Logok";

        // FEJLÉC
        const header = document.createElement("div");
        header.className = "width-100";
        header.append(title);
        section.appendChild(header);

        const rowContainer = document.createElement("div");
        rowContainer.className = "list-row-container overflow-y";
        logs.forEach(log => {
            const row = document.createElement("div");
            row.className = "list-row";
            const main = document.createElement("div");
            main.className = "list-row-main";
            main.innerHTML = 
            this.store.config.isSmall ? 
            `   <div class="log-title">LOG típus: ${log.actiontype}</div>
                <div class="list-row-subtitle font-18 weight-600">Mi változott: ${log.originalparameter}</div>
                <div class="list-row-subtitle font-18 weight-600">Mire változott: ${log.modifiedparameter}</div>
                <div class="list-row-subtitle font-18 weight-600">LOG létrehozása: ${this.formatTimestamp(log.timestamp)}</div>
            ` 
            : `   <div class="log-title">LOG típus: ${log.actiontype}</div>
                <div class="list-row-subtitle font-10 weight-600">Mi változott: ${log.originalparameter}</div>
                <div class="list-row-subtitle font-10 weight-600">Mire változott: ${log.modifiedparameter}</div>
                <div class="list-row-subtitle font-10 weight-600">LOG létrehozása: ${this.formatTimestamp(log.timestamp)}</div>
            `
            ;

            // PDF
            const pdfUrl = log.storegeurl || (log.pdf && log.pdf !== "NOPDF" ? log.pdf : null);
            if (pdfUrl) {
                const pdfButton = document.createElement("img");
                pdfButton.src = "/assets/pdf.png";
                pdfButton.className = "logs-pdf-button";
                pdfButton.title = "PDF megnyitása";
                pdfButton.addEventListener("click", e => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(pdfUrl, "_blank");
                });
                main.appendChild(pdfButton);
            }
            row.appendChild(main);
            rowContainer.appendChild(row);

        });
        section.appendChild(rowContainer);
        this.resultsContainer.appendChild(section);
        return this.resultsContainer;
    }

    formatTimestamp(value) {
        // Már Firestore Timestamp objektum
        if (value?.toDate) {return value.toDate().toLocaleString("hu-HU");}
        // String
        if (typeof value !== "string") {return "";}
        // 1. formátum: 12/9/2025 13:04
        const shortMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})$/);
        if (shortMatch) {
            const [, month, day, year, hour, minute] = shortMatch;
            const date = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute));
            return this.formatDate(date);
        }
        // 2. formátum:
        // August 11, 2026 at 9:01:16 AM UTC+2
        const longMatch = value.match(/^([A-Za-z]+)\s+(\d{1,2}),\s+(\d{4})\s+at\s+(\d{1,2}):(\d{2}):(\d{2})\s+(AM|PM)\s+UTC([+-]\d+)$/);
        if (longMatch) {
            const [, monthName, day, year, hour12, minute, second, ampm, timezone] = longMatch;
            const months = {January: 0, February: 1, March: 2, April: 3, May: 4, June: 5, July: 6, August: 7, September: 8, October: 9, November: 10, December: 11};
            let hour = Number(hour12);
            if (ampm === "PM" && hour !== 12) {hour += 12;}
            if (ampm === "AM" && hour === 12) {hour = 0;}
            // UTC+2 / UTC+1 kezelése
            const offset = Number(timezone);
            const date = new Date(Date.UTC(Number(year), months[monthName], Number(day), hour - offset, Number(minute), Number(second)));
            return this.formatDate(date);
        }
        return value;
    }


    formatDate(date) {
        return `${date.getFullYear()}.` +
            `${String(date.getMonth() + 1).padStart(2, "0")}.` +
            `${String(date.getDate()).padStart(2, "0")} ` +
            `${String(date.getHours()).padStart(2, "0")}:` +
            `${String(date.getMinutes()).padStart(2, "0")}`;
    }

   
}